import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { DestroyOptions } from "pixi.js";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";
import { Manager } from "../../core/Manager";
import { SoundManager } from "../../core/SoundManager";
import { wait } from "../../core/utils";
import { EventConstants } from "../../gameClientEvents/EventConstants";
import { GameConstants } from "../../gameClientEvents/GameConstants";
import { GameEvents } from "../../gameClientEvents/GameEvents";
import { SoundConstants } from "../../gameClientEvents/SoundConstants";

export class GameIntro extends DisplayObject {
    private gameIntro: Spine | null = null;
    private introTransition: Spine | null = null;

    private introReadyEmitted: boolean = false;
    private transitionCompleted: boolean = false;

    constructor(config: IDisplayObject) {
        super(config);
        this.init();
    }

    public override destroy(options?: DestroyOptions): void {
        super.destroy(options);
    }

    public async play() {
        if (!this.gameIntro) return;

        this.gameIntro.state.addListener({
            start: () => {
                // sound.play(SoundConstants.INTRO_MUSIC, {
                //     volume: 1,
                // });
                SoundManager.play(SoundConstants.INTRO_MUSIC, {
                    volume: 1,
                });

            },
            event: async (_entry, event) => {
                if (event.data.name === "change") {
                    this.playTransition();
                }
            },
            complete: () => {
                // this.onIntroComplete(); // Removing from here to allow change when transition event occurs.
            }
        });
        await wait(200);
        this.gameIntro.eventMode = 'static';
        this.gameIntro.interactive = true;
        // this.gameIntro?.on("pointerup", this.onIntroComplete, this);
        this.gameIntro.state.setAnimation(0, "animation", false);
    }

    private emitGameReady(): void {

        if (this.introReadyEmitted) return;

        this.introReadyEmitted = true;

        GameEvents.emitter.emit(
            EventConstants.GAME_INTRO_COMPLETE
        );
    }

    private emitTransitionComplete(): void {

        if (this.transitionCompleted) return;

        this.transitionCompleted = true;

        GameEvents.emitter.emit(
            EventConstants.GAME_TRANSITION_COMPLETE
        );
    }

    private finalizeIntro() {

        this.cleanupGameIntro();
        this.cleanupTransition();

        SoundManager.stop("Intro_transition");

        this.destroy();
    }

    private cleanupGameIntro(): void {

        if (!this.gameIntro) return;

        this.gameIntro.state.clearListeners();

        this.removeChild(this.gameIntro);

        this.gameIntro.destroy(true);

        this.gameIntro = null;
    }

    private cleanupTransition(): void {

        if (!this.introTransition) return;

        this.introTransition.state.clearListeners();

        this.removeChild(this.introTransition);

        this.introTransition.destroy(true);

        this.introTransition = null;
    }

    private init(): void {

        this.gameIntro = Spine.from({
            skeleton: "gameIntroSkel",
            atlas: "gameIntroAtlas"
        });

        this.gameIntro.label = "gameIntro";

        this.addChild(this.gameIntro);

        this.setPositionResize(
            Manager.Orientation || "LANDSCAPE"
        );

        this.play();
    }

    private async playTransition() {

        if (!this.gameIntro) return;

        this.introTransition = Spine.from({
            skeleton: "bannerTransitionSkel",
            atlas: "bannerTransitionAtlas"
        });

        this.introTransition.label = "introTransition";

        this.addChildAt(this.introTransition, 1);
        SoundManager.play('base_music_ambient', { loop: true, volume: 0.5 });
        this.introTransition.state.addListener({

            start: () => {

            },

            event: async (_entry, event) => {

                if (event.data.name === "event") {

                    this.emitGameReady();

                    this.cleanupGameIntro();
                }

                if (event.data.name === "open") {
                    this.emitTransitionComplete();
                }

            },

            complete: () => {

                // this.emitTransitionComplete();

                this.finalizeIntro();
            }
        });

        await wait(200);

        this.introTransition.eventMode = "static";
        this.introTransition.interactive = true;

        this.introTransition.state.setAnimation(0, "animation", false);
    }

    public override setPositionResize(
        orientation: string
    ): void {

        const BG_SCALE_FACTOR = Math.max(
            Manager.screenwidth / GameConstants.BACKGROUND_SIZE,
            Manager.screenHeight / GameConstants.BACKGROUND_SIZE
        );

        let scale;
        let bgScale;

        if (orientation === "LANDSCAPE") {
            scale = 1 * Math.min(Manager.screenwidth / 1920, Manager.screenHeight / GameConstants.GAME_RES_HEIGHT);
        } else {
            scale = 1.0 * Math.min(Manager.screenwidth / 1080, Manager.screenHeight / GameConstants.GAME_RES_WIDTH);
        }

        bgScale = Math.max(scale, BG_SCALE_FACTOR);

        if (this.gameIntro) {

            this.scale.set(bgScale, bgScale);

            const bgXPos = Manager.screenwidth / 2;
            const bgYPos = Manager.screenHeight / 2;

            this.position.set(bgXPos, bgYPos);
        }
    }
}